import { UserWidget } from "../constants/online.homepagegateway.api";
import { ActionTypes } from "./actionTypes";

export const getWidgetsInit = () => ({
    type: ActionTypes.GET_WIDGETS_INIT,
    payload: undefined
});

export const addWidgetInit = (widget: UserWidget) => ({
    type: ActionTypes.ADD_WIDGET,
    payload: widget,
});

export const updateWidgetInit = (widget: UserWidget) => ({
    type: ActionTypes.UPDATE_WIDGET,
    payload: widget,
});

export const deleteWidgetInit = (widget: UserWidget) => ({
    type: ActionTypes.DELETE_WIDGET,
    payload: widget,
});

export const setAddWidgetNotification = (addWidgetNotification?: any) => ({
    type: ActionTypes.SET_ADD_WIDGET_NOTIFICATION,
    payload: addWidgetNotification
});

export const saveWidgetsSuccess = (widgets: UserWidget[], layout: any) => ({
    type: ActionTypes.SAVE_WIDGETS_SUCCESS,
    payload: {widgets: widgets, widgetsLayout: layout}
});

export const saveWidgetsFailure = (error: any) => ({
    type: ActionTypes.SAVE_WIDGETS_FAILURE,
    payload: error
});

export const onDragStop = (layout: any) => ({
    type: ActionTypes.ON_DRAG_STOP,
    payload: layout
});

export const saveLayoutToDB = (layout: any) => ({
    type: ActionTypes.SAVE_WIDGETS_LAYOUT_TO_DB,
    payload: layout
});

export const onWidgetResize = (resizeDetail: any) => ({
    type: ActionTypes.ON_WIDGET_RESIZE,
    payload: resizeDetail
});

export const resetWidgets = () => ({
    type: ActionTypes.RESET_WIDGETS,
    payload: undefined
});

export const windowWidthChanged = (windowWidth: number, containerWidth: number) => ({
    type: ActionTypes.WINDOW_WIDTH_CHANGED,
    payload: {windowWidth: windowWidth, containerWidth: containerWidth}
});

export type WidgetActions = ReturnType<typeof getWidgetsInit>
  | ReturnType<typeof addWidgetInit>
  | ReturnType<typeof updateWidgetInit>
  | ReturnType<typeof deleteWidgetInit>
  | ReturnType<typeof setAddWidgetNotification>
  | ReturnType<typeof saveWidgetsSuccess>
  | ReturnType<typeof saveWidgetsFailure>
  | ReturnType<typeof resetWidgets>
  | ReturnType<typeof onDragStop>  
  | ReturnType<typeof saveLayoutToDB>  
  | ReturnType<typeof onWidgetResize>
  | ReturnType<typeof windowWidthChanged>;